import ExtendRentalInformationModal from './ExtendRentalInformationModal';

export default ExtendRentalInformationModal;
